export enum Cookie {
  Jwt = "jwt_token",
}
